import React from "react";

import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import cx from "apps/website/utils/misc/cx";

import { IDefaultOption } from "../RadioButtons.types";

const DefaultOption = React.forwardRef<HTMLDivElement, IDefaultOption>((props, ref) => (
  <div
    data-component={props.component ?? DefaultOption.name}
    data-value={props.value}
    aria-disabled={props.disabled}
    className="w-full"
    ref={ref}
  >
    <TextSubtitle
      size={2}
      className={cx(
        "flex flex-column justify-center items-center border rounded-xl p-3",
        props.selected ? "bg-black text-white" : "border border-solid border-outline-grey bg-white",
      )}
    >
      { props.label }
    </TextSubtitle>
  </div>
));

DefaultOption.displayName = "DefaultOption";

export default DefaultOption;
